import { DateTime } from "luxon";

const DetectionResultBox = ({ detectionResult }) => {
  if (!detectionResult) return null;

  // Calculer la durée depuis l'EP de référence
  const calculateDuration = (dateEP) => {
    if (!dateEP) return null;
    const epDate = DateTime.fromISO(dateEP);
    const now = DateTime.local();
    const diff = now.diff(epDate, ["months", "days"]);
    const months = Math.floor(diff.months);
    const days = Math.floor(diff.days % 30);
    return { months, days, formattedDate: epDate.toFormat("dd/MM/yyyy") };
  };

  const duration = detectionResult.dateEP
    ? calculateDuration(detectionResult.dateEP)
    : null;

  const boxStyles = {
    PREMIER: {
      bg: "#d1ecf1",
      border: "#17a2b8",
      color: "#0c5460",
      icon: "ℹ️",
      title: "PREMIER MANQUEMENT",
    },
    PERSISTANCE: {
      bg: "#fff3cd",
      border: "#ff9800",
      color: "#856404",
      icon: "🟠",
      title: "PERSISTANCE DÉTECTÉE",
    },
    REITERATION: {
      bg: "#f8d7da",
      border: "#dc3545",
      color: "#721c24",
      icon: "🔴",
      title: "RÉITÉRATION DÉTECTÉE",
    },
  };

  const style = boxStyles[detectionResult.type];
  if (!style) return null;

  return (
    <div
      className="p-3 rounded mb-4"
      style={{
        background: style.bg,
        border: `1px solid ${style.border}`,
        boxShadow: `0 4px 12px ${style.border}33`,
      }}
    >
      <div className="d-flex align-items-center mb-2">
        <span style={{ fontSize: 24 }}>{style.icon}</span>
        <strong className="ml-2" style={{ color: style.color, fontSize: 16 }}>
          {style.title}
        </strong>
      </div>
      <p className="p-2 rounded mb-0" style={{ fontSize: 13 }}>
        {detectionResult.type === "PREMIER" && (
          <>
            Il s'agit du premier manquement connu pour cet allocataire (depuis
            le 01/06/2025).
            <br />
            Le barème proposé correspondra à une première sanction.
          </>
        )}
        {detectionResult.type === "PERSISTANCE" && duration && (
          <>
            Persistance détectée : Même motif que l'EP du{" "}
            <strong>{duration.formattedDate}</strong>, il y a{" "}
            <strong>
              {duration.months > 0 && `${duration.months} mois`}
              {duration.months > 0 && duration.days > 0 && " et "}
              {duration.days > 0 && `${duration.days} jours`}
            </strong>
            .
          </>
        )}
        {detectionResult.type === "REITERATION" && duration && (
          <>
            Réitération détectée : Même motif que l'EP du{" "}
            <strong>{duration.formattedDate}</strong>, il y a{" "}
            <strong>
              {duration.months > 0 && `${duration.months} mois`}
              {duration.months > 0 && duration.days > 0 && " et "}
              {duration.days > 0 && `${duration.days} jours`}
            </strong>
            .
          </>
        )}
      </p>
    </div>
  );
};

export default DetectionResultBox;
